// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__wmbdh","modal":"Modal_modal__19f4N","header":"Modal_header__RLaJ7"};